import React from 'react'
import { Wrapper } from './style'

const ToggleMenu = props => 
  <Wrapper {...props}>
    Menu
  </Wrapper>

export default ToggleMenu



// WEBPACK FOOTER //
// ./src/components/ToggleMenu/index.js